














import { computed, defineComponent } from "@vue/composition-api";

import { ThemProfPropsDef, ThemProfProps } from "@/models";
import SectionDefault from "./section-default.vue";

export default defineComponent<ThemProfPropsDef>({
  name: "Banner",
  components: { SectionDefault },
  props: {
    ...ThemProfProps
  },

  setup(props: ThemProfPropsDef) {
    // computed: multiple random banner image later?
    const image = computed(() => {
      return props.theme.ui.banner.image;
    });

    return { image };
  }
});
